module.exports = __webpack_public_path__ + "static/media/funchal-15.cac20ce3.svg";